// src/router/processos.js

const processosBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Processos',
        to: 'Processos'
    }
]

export default [
    {
        path: '/processos',
        name: 'Processos',
        component: () => import('@/views/Processos/ProcessoListPage.vue'),
        meta: {
            title: 'Processos',
            breadcrumb: processosBreadCrumb
        },
    },
    {
        path: '/processos/novo',
        name: 'ProcessoNovo',
        component: () => import('@/views/Processos/NovoProcessoPage.vue'),
        meta: {
            title: 'Novo Processo',
            breadcrumb: [
                ...processosBreadCrumb,
                {
                    label: 'Novo Processo',
                    to: 'ProcessoNovo'
                }
            ]
        }
    },
    {
        path: '/processos/:id/detalhes',
        name: 'ProcessoDetalhes',
        component: () => import('@/views/Processos/NovoProcessoPage.vue'),
        meta: {
            title: 'Detalhes do Processo',
            breadcrumb: [
                ...processosBreadCrumb,
                {
                    label: 'Detalhes',
                    to: 'ProcessoNovo'
                }
            ]
        }
    },
    {
        path: '/processos/:id/detalhe/container/:containerId',
        name: 'ProcessoDetalhesContainer',
        component: () => import('@/views/Processos/NovoProcessoPage.vue'),
        meta: {
            title: 'Detalhes do Processo',
            breadcrumb: [
                ...processosBreadCrumb,
                {
                    label: 'Detalhes',
                    to: 'ProcessoNovo'
                }
            ]
        }
    },
    {
        path: '/processos/:id/detalhe/acompanhamentos',
        name: 'ProcessoDetalhesAcompanhamentos',
        component: () => import('@/views/Processos/NovoProcessoPage.vue'),
        meta: {
            title: 'Detalhes do Processo',
            breadcrumb: [
                ...processosBreadCrumb,
                {
                    label: 'Detalhes',
                    to: 'ProcessoNovo'
                }
            ]
        }
    }
];
